// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEmployeeListCustomFilterMutationVariables = Types.Exact<{
  input: Types.CreateEmployeeListCustomFilterInput;
}>;

export type CreateEmployeeListCustomFilterMutation = { __typename?: 'Mutation' } & {
  createEmployeeListCustomFilter: { __typename?: 'EmployeeListCustomFilterOutput' } & Pick<
    Types.EmployeeListCustomFilterOutput,
    'id'
  >;
};

export const CreateEmployeeListCustomFilterDocument = /*#__PURE__*/ gql`
    mutation createEmployeeListCustomFilter($input: CreateEmployeeListCustomFilterInput!) {
  createEmployeeListCustomFilter(input: $input) {
    id
  }
}
    `;
export type CreateEmployeeListCustomFilterMutationFn = Apollo.MutationFunction<
  CreateEmployeeListCustomFilterMutation,
  CreateEmployeeListCustomFilterMutationVariables
>;

/**
 * __useCreateEmployeeListCustomFilterMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeListCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeListCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeListCustomFilterMutation, { data, loading, error }] = useCreateEmployeeListCustomFilterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeListCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEmployeeListCustomFilterMutation,
    CreateEmployeeListCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEmployeeListCustomFilterMutation, CreateEmployeeListCustomFilterMutationVariables>(
    CreateEmployeeListCustomFilterDocument,
    options,
  );
}
export type CreateEmployeeListCustomFilterMutationHookResult = ReturnType<
  typeof useCreateEmployeeListCustomFilterMutation
>;
export type CreateEmployeeListCustomFilterMutationOptions = Apollo.BaseMutationOptions<
  CreateEmployeeListCustomFilterMutation,
  CreateEmployeeListCustomFilterMutationVariables
>;
